import {Box, Grid} from '@mui/material';
import {FC, useEffect} from 'react';
import {useParams} from 'react-router-dom';
import {usersApi} from 'src/api';
import {useAppDispatch, useAppSelector} from 'src/app/hooks';
import {PageHeader} from 'src/components/common/PageHeader';
import {TechnicalTeamDetails} from 'src/components/technicalTeam/TechnicalTeamDetails';
import {preloaderChangeStatus} from 'src/stores/common/commonSlice';
import {AppDispatch, UserByIdRequest} from 'src/types';
import {isErrorObject} from 'src/utils/helper';
import {NotifyError} from 'src/utils/notification';
import {pageSx} from '../UserInfo/UserInfo.sx';

type UserQueryTrigger = ReturnType<typeof usersApi.useLazyGetUserByIdQuery>[0];

const handleGetUserInfo =
    (trigger: UserQueryTrigger, dispatch: AppDispatch) => async (data: UserByIdRequest) => {
        dispatch(preloaderChangeStatus(true));
        try {
            return await trigger(data).unwrap();
        } catch (error) {
            if (isErrorObject(error)) {
                NotifyError(error.data.message);
            }
        } finally {
            dispatch(preloaderChangeStatus(false));
        }
    };

export const TechnicalTeamInfo: FC = () => {
    const params = useParams();
    const {authInfo, activeBusiness} = useAppSelector((state) => state.common);

    const dispatch = useAppDispatch();
    const [trigger, response] = usersApi.useLazyGetUserByIdQuery();

    useEffect(() => {
        Object.keys(authInfo).length &&
        params.id &&
        void handleGetUserInfo(trigger, dispatch)({userId: +params.id, businessId: activeBusiness});
        // On the id: the route stays the same between two people, so an empty list left the first
        // one on screen.
    }, [params.id, authInfo, activeBusiness]);

    return (
        <Box sx={pageSx}>
            {response.data && <TechnicalTeamDetails data={response.data}/>}
        </Box>
    );
};
